import axios from "@/config/backend-service";

const state = {
  customerTracking: [],
  dataItem: null,
  loading: false,
  error: null,
};

const getters = {
  getCustomerTracking: (state) => state.customerTracking,
  getDataItem: (state) => state.dataItem,
  isLoadingCustomerTracking: (state) => state.loading,
  customerTrackingError: (state) => state.error,
};

const mutations = {
  SET_CUSTOMER_TRACKING(state, payload) {
    state.customerTracking = payload;
  },
  SET_DATA_ITEM(state, payload) {
    state.dataItem = payload;
  },
  SET_LOADING(state, val) {
    state.loading = val;
  },
  SET_ERROR(state, err) {
    state.error = err;
  },
  ADD_CUSTOMER_TRACKING_ITEM(state, payload) {
    state.customerTracking.unshift(payload);
  },
};

const actions = {
  async fetchCustomerTracking({ commit }, payload) {
    const employeeId =
      payload && typeof payload === "object" ? payload.employeeId : payload;
    const filterTrackingSchema =
      payload && typeof payload === "object"
        ? payload.filterTrackingSchema || null
        : null;

    if (!employeeId) {
      const err = new Error("employeeId is required");
      commit("SET_ERROR", err.message);
      throw err;
    }

    commit("SET_LOADING", true);
    commit("SET_CUSTOMER_TRACKING", []);
    commit("SET_DATA_ITEM", null);
    commit("SET_ERROR", null);

    try {
      const res = await axios.get(
        `getCustomerServiceTrackingByEmployeeId/${employeeId}`
      );
      const dataResponse = res?.data;

      if (dataResponse?.status !== "success") {
        throw new Error(
          dataResponse?.message || "ระบบขัดข้องกรุณาลองใหม่อีกครั้งภายหลัง"
        );
      }

      const data = dataResponse.data || {};

      // ===== transform tracking_detail =====
      let customer_service_tracking = [];
      if (
        Array.isArray(data.customer_service_tracking) &&
        data.customer_service_tracking.length > 0
      ) {
        let transformed = data.customer_service_tracking.map((x) => {
          let tracking_detail = {};
          if (x.tracking_detail && Array.isArray(x.tracking_schema?.elements)) {
            for (let item of x.tracking_schema.elements) {
              const question_name = item.name;
              const keys = Object.keys(x.tracking_detail || {});
              let checkOther = keys.includes(`${question_name}-Comment`);
              if (keys.includes(question_name)) {
                tracking_detail[question_name] = !checkOther
                  ? x.tracking_detail[question_name]
                  : x.tracking_detail[`${question_name}-Comment`];
              }
            }
          }
          x.tracking_detail = { ...tracking_detail };
          return x;
        });

        if (filterTrackingSchema) {
          transformed = transformed.filter(
            (x) => x.schema_id == filterTrackingSchema
          );
        }

        customer_service_tracking = JSON.parse(JSON.stringify(transformed));
      }

      // ===== prepare dataItem =====
      const data_new = {
        ...data,
        customer_service_tracking,
      };

      if (data_new.customer_services) {
        data_new.customer_service_id = data_new.customer_services.id;
        data_new.customer_service_sale = `${data_new.customer_services.name
          } ${data_new.customer_services.surname || ""}`;
      }

      // commit to store
      commit("SET_CUSTOMER_TRACKING", customer_service_tracking);
      commit("SET_DATA_ITEM", data_new);

      commit("SET_LOADING", false);
      return data_new;
    } catch (err) {
      commit("SET_LOADING", false);
      commit("SET_ERROR", err.message || err);
      console.error("❌ Error fetching customer tracking:", err);
      throw err;
    }
  },

  addCustomerTrackingItem({ commit }, item) {
    commit("ADD_CUSTOMER_TRACKING_ITEM", item);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
